// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"4e44a355a6b76d4c","8309":"14d9b7ea0117ca96"}[chunkId] + ".css";
};